import { buildApiUrl } from '../config/api';
import {
  PromotionImageUploadResponse,
  PromotionMutationRequest,
  PromotionMutationResponse,
  PromotionsResponse,
} from '../models/Promotion';
import { secureTokenManager } from '../utils/secureTokenManager';

const adminHeaders = (): Record<string, string> => ({
  'Content-Type': 'application/json',
  'Accept': 'application/json',
  'Authorization': `Bearer ${secureTokenManager.getAdminSessionToken()}`,
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  'Pragma': 'no-cache',
});

const adminUploadHeaders = (): Record<string, string> => ({
  'Accept': 'application/json',
  'Authorization': `Bearer ${secureTokenManager.getAdminSessionToken()}`,
  'Cache-Control': 'no-cache, no-store, must-revalidate',
  'Pragma': 'no-cache',
});

const parseResponse = async <T>(response: Response): Promise<T> => {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || data.message || `HTTP error! status: ${response.status}`);
  }
  return data as T;
};

export class PromotionService {
  static async uploadPromotionImage(file: File): Promise<PromotionImageUploadResponse> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('purpose', 'promotion');

    const response = await fetch(buildApiUrl('/uploads/images'), {
      method: 'POST',
      headers: adminUploadHeaders(),
      body: formData,
    });
    return parseResponse<PromotionImageUploadResponse>(response);
  }

  static async getPromotions(): Promise<PromotionsResponse> {
    const response = await fetch(buildApiUrl('/promotions/admin?page=1&limit=100'), {
      method: 'GET',
      headers: adminHeaders(),
    });
    return parseResponse<PromotionsResponse>(response);
  }

  static async createPromotion(data: PromotionMutationRequest): Promise<PromotionMutationResponse> {
    const response = await fetch(buildApiUrl('/promotions/admin'), {
      method: 'POST',
      headers: adminHeaders(),
      body: JSON.stringify(data),
    });
    return parseResponse<PromotionMutationResponse>(response);
  }

  static async updatePromotion(
    promotionId: string,
    data: PromotionMutationRequest
  ): Promise<PromotionMutationResponse> {
    const response = await fetch(buildApiUrl(`/promotions/admin/${promotionId}`), {
      method: 'PUT',
      headers: adminHeaders(),
      body: JSON.stringify(data),
    });
    return parseResponse<PromotionMutationResponse>(response);
  }

  static async deletePromotion(promotionId: string): Promise<PromotionMutationResponse> {
    const response = await fetch(buildApiUrl(`/promotions/admin/${promotionId}`), {
      method: 'DELETE',
      headers: adminHeaders(),
    });
    return parseResponse<PromotionMutationResponse>(response);
  }
}
